import React, { useEffect } from "react";
import { HubConnectionBuilder } from '@microsoft/signalr';
import { useSelector, useDispatch } from "react-redux";
import { OnboardingAxios, UserActivityAxios, ProgramSetupAxios } from "../../API";
import { POINT_TYPE } from "../Enum";

import authSlice from "../../store/auth/authSlice";
import notificationSlice from "../../store/notification/notificationSlice";
import leaderboardSlice from "../../store/journeyMap/leaderboardSlice";
import offeringConfigurationSlice from "../../store/offeringConfiguration/offeringConfigurationSlice";
import { LeftNavigation } from "../../apiCollection";
const SignalR = () => {
    const userDetails = useSelector((state) => state.auth.loggedInUser);

    const dispatch = useDispatch();
    // const [connection, setConnection] = useState(null);

    useEffect(() => {
        const connection = new HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_SIGNALR)
            .withAutomaticReconnect()
            .build();

        connection.start()
            .then(result => {
                console.log('Connected!::::: ' + result);
                // setConnection(connection.connectionId);
                dispatch(
                    authSlice.actions.setConnectionId(connection.connectionId)
                );
                connection.on('Broadcast', message => {
                    if (message == "Update-Leaderboard") {
                        //update leaderboard
                        getLeaderboard();
                        getNotifications();
                    }
                    if (message == "Update-Activity-Details") {
                        //update activity data here
                        getNotifications();
                        getLeftNavigation();
                        getNotifications();
                    }
                });

                connection.on('BroadcastToTeam', message => {
                    if (message == "BroadcastToTeam-" + userDetails.teamId) {
                        GetPoints();
                        getNotifications();
                    }
                });
                connection.on('BroadcastToOffering', message => {
                    if (message == "BroadcastToOffering-" + userDetails.offeringId) {
                        // GetPoints();
                        // getNotifications();
                        getNotifications();
                        // getFeeds();
                    }
                });
                connection.on('BroadcastToOfferingUser', message => {
                    if (message == "BroadcastToOfferingUser-" + userDetails.offeringUserId) {
                        GetPoints();
                        getNotifications();
                    }
                });

                connection.on('Notification', message => {
                    if (message == "points-award") {
                        GetPoints();
                        getNotifications();
                    }
                });

            })
            .catch(e => console.log('Connection failed: ', e));
    }, []);

    // const send = async () => {
    //     try {
    //         await connection.send('Broadcast', "chatMessage");
    //     }
    //     catch (e) {
    //         console.log(e);
    //     }
    // }

    const GetPoints = () => {
        OnboardingAxios.get('OfferingUsers/getuserpoints/' + userDetails.offeringUserId)
            .then(function (response) {
                let data = response.data;
                dispatch(
                    authSlice.actions.setPoints({
                        currentLevel: data.currentLevel,
                        currentRank: data.currentRank,
                        teamRank: data.teamRank,
                        pointsToNextBadge: data.pointsToNextBadge,
                        totalPoints: data.totalPoints,
                        experiencePoints: (data.points.find(x => x.pointsType == POINT_TYPE.experience) ? data.points.find(x => x.pointsType == POINT_TYPE.experience).points : 0) || 0,
                        bonusPoints: (data.points.find(x => x.pointsType == POINT_TYPE.bonus) ? data.points.find(x => x.pointsType == POINT_TYPE.bonus).points : 0) || 0,
                    })
                );
            });
    };

    const getNotifications = () => {
        getOfferingMission();
        UserActivityAxios.get("Notification/getnotifications/" + userDetails.offeringUserId + "/1/10")
            .then(function (res) {
                dispatch(notificationSlice.actions.setNotificationList(res.data));
            })
            .catch(function (er) {
                console.log(er);
            });

    };

    const getLeaderboard = () => {
        UserActivityAxios.get(
            `Leaderboard/getleaderboard/${userDetails.offeringId}/${userDetails.missionId}/${userDetails.teamId}`
        )
            .then(function (response) {
                dispatch(leaderboardSlice.actions.setLeaderboard(response.data));
            })
            .catch(function (error) { console.log(error); });

    };

    const getLeftNavigation = () => {
        LeftNavigation('/OfferingConfiguration/leftnavigation/' + userDetails.offeringId + '/' + userDetails.missionId + '/' + userDetails.offeringUserId)
            // ProgramSetupAxios.get('/OfferingConfiguration/leftnavigation/' + userDetails.offeringId + '/' + userDetails.missionId + '/' + userDetails.offeringUserId)
            .then(function (response) {
                let data = response.data;
                dispatch(offeringConfigurationSlice.actions.setLeftNavigation(data));
                //  getProgress(data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const getOfferingMission = () => {
        ProgramSetupAxios.get(
            "OfferingMission/getmissionbyid/" +
            userDetails.missionId +
            "/" +
            userDetails.offeringUserId
        )
            .then(function (missionReponse) {
                dispatch(
                    authSlice.actions.setMissionDetails(missionReponse.data)
                );
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    return (
        <>
            {/* <button type="button" onClick={send}>Send Msg</button> */}
        </>
    );
};

export default SignalR;
